import { ISelectOption } from './selectOption.interface';
import { AuthenticationMethod, Platform } from '../api/common';

const ApiKeyLabelPath = 'integrationPage.authDetails.apiKeyFieldKey';
const UserPasswordLabelPath = 'integrationPage.authDetails.userPasswordMethod';

export const PlatformToAuthenticationMethodsSelectOptions: {
  [platform: string]: ISelectOption[];
} = {
  [Platform.workato]: [
    {
      id: AuthenticationMethod.apikey,
      value: AuthenticationMethod.apikey,
      displayName: ApiKeyLabelPath,
    },
    {
      id: AuthenticationMethod.apitoken,
      value: AuthenticationMethod.apitoken,
      displayName: 'integrationPage.authDetails.apiTokenMethod',
    },
    {
      id: AuthenticationMethod.userpassword,
      value: AuthenticationMethod.userpassword,
      displayName: UserPasswordLabelPath,
    },
    {
      id: AuthenticationMethod.oktasso,
      value: AuthenticationMethod.oktasso,
      displayName: 'integrationPage.authDetails.oktaSsoMethod',
    },
  ],
  [Platform.serviceNow]: [
    {
      id: AuthenticationMethod.oauthAuthorizationCode,
      value: AuthenticationMethod.oauthAuthorizationCode,
      displayName: 'integrationPage.authDetails.oauthMethod',
    },
  ],
  [Platform.powerplatform]: [
    {
      id: AuthenticationMethod.userpassword,
      value: AuthenticationMethod.userpassword,
      displayName: UserPasswordLabelPath,
      disabled: true,
    },
    {
      id: AuthenticationMethod.oauthAuthorizationCode,
      value: AuthenticationMethod.oauthAuthorizationCode,
      displayName: 'integrationPage.authDetails.oauthMethod',
    },
    {
      id: AuthenticationMethod.serviceprincipal,
      value: AuthenticationMethod.serviceprincipal,
      displayName: 'integrationPage.authDetails.servicePrincipalMethod',
    },
    {
      id: AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal,
      value: AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal,
      displayName: 'integrationPage.authDetails.ppZenityMultiTenantAppServicePrincipalMethod',
    },
  ],
  [Platform.powerBI]: [
    {
      id: AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal,
      value: AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal,
      displayName: 'integrationPage.authDetails.ppZenityMultiTenantAppServicePrincipalMethod',
    },
    {
      id: AuthenticationMethod.serviceprincipal,
      value: AuthenticationMethod.serviceprincipal,
      displayName: 'integrationPage.authDetails.servicePrincipalMethod',
    },
  ],
  [Platform.salesforce]: [
    {
      id: AuthenticationMethod.oauthClientCredentialsFlow,
      value: AuthenticationMethod.oauthClientCredentialsFlow,
      displayName: 'integrationPage.authDetails.oauthClientCredentialsFlowMethod',
    },
    {
      id: AuthenticationMethod.jwtBearerFlow,
      value: AuthenticationMethod.jwtBearerFlow,
      displayName: 'integrationPage.authDetails.jwtBearerFlowMethod',
    },
  ],
  [Platform.chatGptEnterprise]: [
    {
      id: AuthenticationMethod.apikey,
      value: AuthenticationMethod.apikey,
      displayName: 'integrationPage.authDetails.apiKeyMethod',
    },
  ],
  [Platform.amazonBedrock]: [
    {
      id: AuthenticationMethod.iamRole,
      value: AuthenticationMethod.iamRole,
      displayName: 'integrationPage.authDetails.iamRoleMethod',
    },
  ],
  [Platform.google]: [
    {
      id: AuthenticationMethod.serviceAccount,
      value: AuthenticationMethod.serviceAccount,
      displayName: 'integrationPage.authDetails.serviceAccountMethod',
    },
    {
      id: AuthenticationMethod.serviceAccountManaged,
      value: AuthenticationMethod.serviceAccountManaged,
      displayName: 'integrationPage.authDetails.serviceAccountManagedMethod',
    },
  ],
  [Platform.devices]: [
    {
      id: AuthenticationMethod.enrollmentKey,
      value: AuthenticationMethod.enrollmentKey,
      displayName: 'integrationPage.authDetails.enrollmentKeyMethod',
    },
  ],
  [Platform.budibase]: [
    {
      id: AuthenticationMethod.apikey,
      value: AuthenticationMethod.apikey,
      displayName: ApiKeyLabelPath,
    },
  ],
  [Platform.airtable]: [
    {
      id: AuthenticationMethod.apikey,
      value: AuthenticationMethod.apikey,
      displayName: 'integrationPage.authDetails.personalAccessTokenMethod',
    },
  ],
  [Platform.outpost_powerplatform]: [
    {
      id: AuthenticationMethod.managedIdentity,
      value: AuthenticationMethod.managedIdentity,
      displayName: 'integrationPage.authDetails.outpostManagedIdentityMethod',
    },
  ],
  [Platform.cursor]: [
    {
      id: AuthenticationMethod.enrollmentKey,
      value: AuthenticationMethod.enrollmentKey,
      displayName: 'integrationPage.authDetails.cursorHooksMethod',
    },
  ],
};
